import type { MenuModel } from '@ay-shared-core/types/admin'
import { getUserInfo } from '@/utils/token'

// 非菜单路由的标签（不在侧边栏显示，但面包屑需要）
const extraRouteLabels: Record<string, string> = {
  '/profile': '个人信息',
  '/billing/entity-net-balance': '实体净账查询',
}

/** 从 MenuModel 树递归构建 path → label 映射 */
function buildRouteLabelMapFromMenus(menus: MenuModel[]): Record<string, string> {
  const map: Record<string, string> = {}
  for (const menu of menus) {
    if (menu.path) {
      map[menu.path] = menu.name
    }
    if (menu.children && menu.children.length > 0) {
      Object.assign(map, buildRouteLabelMapFromMenus(menu.children))
    }
  }
  return map
}

/**
 * 从 localStorage 中的用户菜单数据构建 path → label 映射（面包屑使用）
 * 每次调用都读取最新数据，确保用户切换后面包屑正确
 */
export const getRouteLabelMap = (): Record<string, string> => {
  const userInfo = getUserInfo()
  const menus = userInfo?.menus ?? []
  return {
    ...buildRouteLabelMapFromMenus(menus),
    ...extraRouteLabels,
  }
}
